// src/QrScanPage.js
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import apis from "../services";
import {
  QRAPPS,
  QRBUSINESS,
  QREVENT,
  QRGALLERY,
  QRLANDING,
  QRLINK,
  QRPDF,
  QRSOCIAL,
  QRVCARD,
  QRVIDEO,
  QRYOUTUBE,
} from "./QRScanRedirectUI/AllQRType";
import {
  QRPreviewApps,
  QRPreviewBusiness,
  QRPreviewElabelsBeer,
  QRPreviewElabelsBeerScan,
  QRPreviewElabelsCigar,
  QRPreviewElabelsCigarScan,
  QRPreviewElabelsCoffee,
  QRPreviewElabelsCoffeeScan,
  QRPreviewElabelsFood,
  QRPreviewElabelsFoodScan,
  QRPreviewElabelsProduct,
  QRPreviewElabelsProductScan,
  QRPreviewElabelsWine,
  QRPreviewElabelsWineScan,
  QRPreviewEvent,
  QRPreviewGallery,
  QRPreviewLanding,
  QRPreviewLinks,
  QRPreviewPdf,
  QRPreviewSocial,
  QRPreviewVCard,
} from "./QRDetailPages/QRPreviewAll";
import { ChangeLanguageModal, FeedbackModal } from "../components/index.js";
import { clearTranslatedData } from "../redux/slice/LanguageSlice.js";
import { useDispatch } from "react-redux";

const ScanAndRedirectQr = () => {
  const { qrCodeId } = useParams();
  const [loading, setLoading] = useState(true);
  const [outcomeContent, setOutcomeContent] = useState(null);
  const [error, setError] = useState(null);
  const [qrType, setQrType] = useState(null);
  const [ShowChangeLanguage, setShowChangeLanguage] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const dispatch = useDispatch();
  // console.log("qrCodeId", qrCodeId);

  // Function to detect the operating system
  const getOperatingSystem = () => {
    const userAgent = window.navigator.userAgent;
    const platform = window.navigator.platform;

    if (platform.startsWith("Win")) return "Windows";
    if (platform.startsWith("Mac")) return "MacOS";
    if (platform.startsWith("Linux")) return "Linux";
    if (/Android/.test(userAgent)) return "Android";
    if (/iPhone|iPad|iPod/.test(userAgent)) return "iOS";
    return "Unknown OS";
  };

  useEffect(() => {
    const trackQrScan = async () => {
      try {
        const os = getOperatingSystem();
        let dataToSend = {
          id: qrCodeId,
          os: os,
        };

        // console.log("DATATOSEND", dataToSend);

        let res = await apis.scanQrCode(dataToSend);
        // console.log("Response Scan QR Code", res?.data?.outcome?.questions);

        if (res && res.data && res.data.outcome) {
          const outcome = res.data.outcome;
          // console.log("outcomeLog", outcome);

          if (outcome.type === "url") {
            window.location.href = outcome.field_url;
          } else {
            dispatch(clearTranslatedData());

            setOutcomeContent(outcome);
            setQrType(outcome?.type);
          }
        } else {
          console.error("Invalid response data", res);
          setError("Invalid response data");
        }
      } catch (error) {
        console.error("Failed to track QR Code scan", error);
        setError("Failed to track QR Code scan");
      } finally {
        setLoading(false);
      }
    };

    trackQrScan();
  }, [qrCodeId]);

  console.log("outcomeContent", outcomeContent);

  useEffect(() => {
    // console.log("qrType", qrType);
  }, [qrType]);

  const renderContentByType = () => {
    if (qrType === "elabels") {
      const products = ["wine", "beer", "cigars", "coffee", "food", "product"];

      const matchedProduct = products.find(
        (product) => outcomeContent[product] === "true"
      );
      // console.log("matchedProduct", matchedProduct);

      switch (matchedProduct) {
        case "wine":
          return (
            <QRPreviewElabelsWineScan
              localQrData={outcomeContent}
              className={"ScanPageClass"}
              showReview
            />
          );
        case "beer":
          return (
            <QRPreviewElabelsBeerScan
              localQrData={outcomeContent}
              className={"ScanPageClass"}
              showReview
            />
          );
        case "cigars":
          return (
            <QRPreviewElabelsCigarScan
              localQrData={outcomeContent}
              className={"ScanPageClass"}
              showReview
            />
          );
        case "coffee":
          return (
            <QRPreviewElabelsCoffeeScan
              localQrData={outcomeContent}
              className={"ScanPageClass"}
              showReview
            />
          );
        case "food":
          return (
            <QRPreviewElabelsFoodScan
              localQrData={outcomeContent}
              className={"ScanPageClass"}
              showReview
            />
          );
        case "product":
          return (
            <QRPreviewElabelsProductScan
              localQrData={outcomeContent}
              className={"ScanPageClass"}
              showReview
            />
          );
        default:
          return <div>No product selected</div>;
      }
    }

    switch (qrType) {
      case "youtube":
        return <QRYOUTUBE qrContent={outcomeContent} />;
      case "pdf":
        return <QRPreviewPdf localQrData={outcomeContent} />;
      case "video":
        return <QRVIDEO qrContent={outcomeContent} />;
      case "vcard":
        // return <QRVCARD qrContent={outcomeContent} />;
        return <QRPreviewVCard localQrData={outcomeContent} />;
      case "business_page":
        return <QRPreviewBusiness localQrData={outcomeContent} />;
      case "social_media":
        return <QRPreviewSocial localQrData={outcomeContent} />;
      case "apps":
        return <QRPreviewApps localQrData={outcomeContent} />;
      case "links":
        return <QRPreviewLinks localQrData={outcomeContent} />;
      case "image_gallery":
        return <QRPreviewGallery localQrData={outcomeContent} />;
      case "landing":
        return <QRPreviewLanding localQrData={outcomeContent} />;
      case "events":
        return <QRPreviewEvent localQrData={outcomeContent} />;
      case "elabels":
        return "ELABELS TESTTTTTTTT";
      default:
        return <div>Not Found</div>;
    }
  };

  console.log("outcomeContentoutcomeContent", outcomeContent);

  // const translatedQrData = {
  //   original_payload: {
  //     business_about: "indicate your business opening hours days",
  //     business_btn_text: "View our product",
  //     business_company: "EA Sport",
  //     business_email: "example@email.com",
  //     business_name: "john smith",
  //     business_phone: "12345667",
  //     business_subtitle: "delicious bread and butter",
  //     business_title: "Fresh title",
  //   },
  // };

  // const getField = (key) => translatedQrData?.original_payload?.[key];

  // console.log("getField result:", getField("business_name"));
  // console.log("getField result:", getField("business_email"));

  return (
    <>
      {loading ? (
        <div className="loader-wrapper">
          <div className="loaderr" />
        </div>
      ) : error ? (
        <div>{error}</div>
      ) : outcomeContent ? (
        <div className="scanPageContainer">
          {outcomeContent?.type !== "youtube" &&
            outcomeContent?.type !== "url" && (
              <button
                className="btn btn-primary custom-lang-btn "
                onClick={() => setShowChangeLanguage(true)}
              >
                🌐 Change Language
              </button>
            )}
          {outcomeContent?.questions?.length > 0 && (
            <button
              className="btn feedback-btn position-fixed bottom-0 end-0 m-3 z-3"
              onClick={() => setShowFeedback(true)}
            >
              ⭐ Rate Us
            </button>
          )}

          {renderContentByType()}
        </div>
      ) : (
        <div>Redirecting...</div>
      )}
      <ChangeLanguageModal
        ShowChangeLanguage={ShowChangeLanguage}
        setShowChangeLanguage={setShowChangeLanguage}
        localQrData={outcomeContent}
      />
      <FeedbackModal
        showFeedback={showFeedback}
        setShowFeedback={setShowFeedback}
        localQrData={outcomeContent}
      />
    </>
  );
};

export default ScanAndRedirectQr;
